import React from 'react'
import {
    Grid
} from '@mui/material'
import InformationTab from '../../Components/Tabs/InformationTab/InformationTab'

export default function SpecializationService() {
  return (
    <Grid container>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <InformationTab/>    
            </Grid>

        </Grid>
  )
}
